import { graphql } from 'react-relay';

export const ChargeView = graphql`
  mutation ChargeViewMutation($input: ChargeViewInput!) {
    ChargeView(input: $input) {
      success
      error
    }
  }
`;
